var exports = {
  "EY": "Text__JIQQEe",
  "MJ": "FormControl__0i8t-r",
  "YJ": "FormControl_1__M_JZSY",
  "ds": "FormControl_2__4RPIa7",
};

module.exports = exports;
